import { createSlice } from "@reduxjs/toolkit";

export const partnerTypesSlice = createSlice({
	name: "partnerTypesTable",
	initialState: {
		initialData: [],
		modifiedData: [],
		addedData: [],
		isOnEditRow: [],
		partnerType: [],
	},
	reducers: {
		getInitialData: (state, actions) => {
			state.initialData = actions.payload;
		},
		getPartnerTypes: (state, actions) => {
			state.partnerType = actions.payload;
		},
		addAddedDataPartnerTypeSlice: (state, actions) => {
			state.addedData.push(actions.payload);
		},
		handleEditChange: (state, actions) => {
			const { name, id, value } = actions.payload.target;
			const foundData = state.initialData.find((x) => x.partnerTypeId === id);
			const foundEditData = state.modifiedData.find(
				(x) => x.partnerTypeId === id
			);

			// Create a copy of the existing data to work with
			let modifyData = {};

			if (foundEditData) {
				// Use existing modified data as the base if it exists
				modifyData = { ...foundEditData };
			} else if (foundData) {
				// Otherwise convert from initial data format
				const lockerTypesArray = [];
				foundData.partnerLockerTypeAccess.forEach((element) => {
					lockerTypesArray.push({
						value: element.lockerType.lockerTypeId,
						label: element.lockerType.lockerType,
					});
				});

				modifyData = {
					operatorId: JSON.parse(localStorage.getItem("user")).operator_id,
					partnerTypeId: foundData.partnerTypeId,
					partnerType: foundData.partnerType,
					partnerCategoryNo: foundData.partnerCategoryNo,
					partnerCategory: foundData.partnerCategory,
					lockerTypes: lockerTypesArray,
					description: foundData.description,
					monthlyFee: foundData.monthlyFee,
				};
			}

			// Update the specific field based on the name
			if (name === "partnerType") {
				modifyData.partnerType = value;
			} else if (name === "partnerCategoryNo") {
				modifyData.partnerCategoryNo = parseInt(value);
			} else if (name === "lockerTypes") {
				// // Handle lockerTypes similar to handleAddChange
				// if (value) {
				// 	const arrayToAssign = [];

				// 	// Handle both array and single object cases
				// 	const itemsToProcess = Array.isArray(value) ? value : [value];

				// 	itemsToProcess.forEach((element) => {
				// 		// If element has a value property, use it; otherwise use the element itself
				// 		if (element && typeof element === "object" && "value" in element) {
				// 			arrayToAssign.push(element);
				// 		} else {
				// 			arrayToAssign.push(element);
				// 		}
				// 	});

				// 	modifyData.lockerTypes = arrayToAssign;
				// }
				// Special handling for MultiSelect component
				// Here value is expected to be the full array of selected options
				if (value && Array.isArray(value)) {
					modifyData.lockerTypes = value;
				}
			} else if (name === "description") {
				modifyData.description = value;
			} else if (
				name === "monthlyFee" &&
				(/^\d+(\.\d{0,2})?$/.test(value) || value === "") &&
				value <= 1000000000.0
			) {
				modifyData.monthlyFee = value;
			}

			// Update state's modifiedData array
			const indexOfTheData = state.modifiedData.findIndex(
				(x) => parseInt(x.partnerTypeId) === parseInt(id)
			);

			if (indexOfTheData !== -1) {
				// Create a new copy of modifiedData for immutability
				const updatedModifiedData = [...state.modifiedData];
				updatedModifiedData[indexOfTheData] = modifyData;
				state.modifiedData = updatedModifiedData;
			} else {
				state.modifiedData.push(modifyData);
			}
		},
		handleAddChange: (state, actions) => {
			const { name, value } = actions.payload.data.target;

			console.log({ SLICE_NAME: name, SLICE_VALUE: value, actions, state });
			const index = actions.payload.index;
			// const tempAddedData = state.addedData;
			const tempAddedData = [...state.addedData];
			// Initialize the object at this index if it doesn't exist
			if (!tempAddedData[index]) {
				tempAddedData[index] = {};
			}
			console.log({ tempAddedData, index });
			const data = tempAddedData[index];
			if (name === "partnerType") {
				data.partnerType = value;
			}
			if (name === "partnerCategoryNo") {
				data.partnerCategoryNo = parseInt(value);
			} else if (name === "lockerTypes") {
				// Handle the specific structure of the lockerTypes data
				const arrayToPush = [];

				// Make sure value is not null/undefined before processing
				if (value) {
					// Handle both array and single object cases
					const itemsToProcess = Array.isArray(value) ? value : [value];

					itemsToProcess.forEach((element) => {
						// If element has a value property, use it; otherwise use the element itself
						if (element && typeof element === "object" && "value" in element) {
							arrayToPush.push(element.value);

							// Optionally, you might want to store the label too in a separate array
							// if (!data.lockerTypeLabels) data.lockerTypeLabels = [];
							// data.lockerTypeLabels.push(element.label);
						} else {
							arrayToPush.push(element);
						}
					});
				}

				data.lockerTypes = arrayToPush;
			}
			if (name === "description") {
				data.description = value;
			}
			if (
				name === "monthlyFee" &&
				(/^\d+(\.\d{0,2})?$/.test(value) || value === "") &&
				value <= 1000000000.0
			) {
				data.monthlyFee = value;
			}
			tempAddedData[index] = data;
			state.addedData = tempAddedData;
		},
		addEditTextfield: (state, actions) => {
			if (actions.payload.target.name === "lockerTypes") {
				const { id, name } = actions.payload.target;
			} else {
				const allKeys = Object.keys(actions.payload.target);
				const { id } = actions.payload.target;
				const { name } = actions.payload.target[allKeys[1]];
				state.isOnEditRow.push(`${name}:${id}`);
			}
		},
		clearPartnerTypeSlice: (state) => {
			state.addedData = [];
			state.modifiedData = [];
			state.isOnEditRow = [];
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getInitialData,
	getPartnerTypes,
	clearPartnerTypeSlice,
	addAddedDataPartnerTypeSlice,
	handleEditChange,
	addEditTextfield,
	handleAddChange,
} = partnerTypesSlice.actions;

export default partnerTypesSlice.reducer;
